export default __webpack_public_path__ + "static/social-default-image-aa9b90a23afd7aadae4357f8abd9d741.png";